import { getCurrencyDetails } from './currency-utils';
var emptyString = '';
var comma = ',';
var period = '.';
var minus = '-';
var minusRegExp = /-/;
var nonDigitsRegExp = /\D+/g;
var number = 'number';
var digitRegExp = /\d/;
var caretTrap = '[]';
export function createNumberMask(_ref) {
  var {
    suffix = emptyString,
    includeThousandsSeparator = true,
    thousandsSeparatorSymbol = comma,
    allowDecimal = false,
    decimalSymbol = period,
    decimalLimit = 2,
    requireDecimal = false,
    allowNegative = false,
    allowLeadingZeroes = false,
    integerLimit,
    currency = 'USD',
    prefix = getCurrencyDetails(currency).sign,
    allowPrefix = true
  } = _ref;
  var prefixLength = allowPrefix && prefix !== null && prefix !== void 0 && prefix.length ? prefix === null || prefix === void 0 ? void 0 : prefix.length : 0;
  var suffixLength = (suffix === null || suffix === void 0 ? void 0 : suffix.length) || 0;
  var thousandsSeparatorSymbolLength = (thousandsSeparatorSymbol === null || thousandsSeparatorSymbol === void 0 ? void 0 : thousandsSeparatorSymbol.length) || 0; // https://github.com/text-mask/text-mask/issues/372#issuecomment-581861405

  function numberMask() {
    var rawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyString;
    var rawValueLength = rawValue.length;
    var prefixArray = prefix.split(emptyString);

    if (rawValue === emptyString || rawValue[0] === prefix[0] && rawValueLength === 1) {
      return prefixArray.concat([digitRegExp]).concat(suffix.split(emptyString));
    } else if (rawValue === decimalSymbol && allowDecimal) {
      return prefixArray.concat(['0', decimalSymbol, digitRegExp]).concat(suffix.split(emptyString));
    }

    var isNegative = rawValue[0] === minus && allowNegative; //If negative remove "-" sign

    if (isNegative) {
      rawValue = rawValue.toString().slice(1);
    }

    var indexOfLastDecimal = rawValue.indexOf(decimalSymbol);
    var lastIndexOfLastDecimal = rawValue.lastIndexOf(decimalSymbol);
    var hasDecimal = indexOfLastDecimal !== -1; // if adding a new decimal point, remove

    if (hasDecimal && indexOfLastDecimal != lastIndexOfLastDecimal) {
      rawValue = rawValue.toString().slice(0, -1);
    }

    var integer;
    var fraction;
    var mask; // remove the suffix

    if (rawValue.slice(suffixLength * -1) === suffix) {
      rawValue = rawValue.slice(0, suffixLength * -1);
    }

    if (hasDecimal && (allowDecimal || requireDecimal)) {
      integer = rawValue.slice(rawValue.slice(0, prefixLength) === prefix ? prefixLength : 0, indexOfLastDecimal);
      fraction = rawValue.slice(indexOfLastDecimal + 1, rawValueLength);
      fraction = convertToMask(fraction.replace(nonDigitsRegExp, emptyString));
    } else {
      if (rawValue.slice(0, prefixLength) === prefix) {
        integer = rawValue.slice(prefixLength);
      } else {
        integer = rawValue;
      }
    }

    if (integerLimit && typeof integerLimit === number) {
      var thousandsSeparatorRegex = thousandsSeparatorSymbol === '.' ? '[.]' : "".concat(thousandsSeparatorSymbol);
      var numberOfThousandSeparators = (new RegExp(thousandsSeparatorRegex, 'g').exec(integer) || []).length;
      integer = integer.slice(0, integerLimit + numberOfThousandSeparators * thousandsSeparatorSymbolLength);
    }

    integer = integer.replace(nonDigitsRegExp, emptyString);

    if (!allowLeadingZeroes) {
      integer = integer.replace(/^0+(0$|[^0])/, '$1');
    }

    integer = includeThousandsSeparator ? addThousandsSeparator(integer, thousandsSeparatorSymbol) : integer;
    mask = convertToMask(integer);

    if (hasDecimal && allowDecimal || requireDecimal === true) {
      if (rawValue[indexOfLastDecimal - 1] !== decimalSymbol) {
        mask.push(caretTrap);
      }

      mask.push(decimalSymbol, caretTrap);

      if (fraction) {
        if (typeof decimalLimit === number) {
          fraction = fraction.slice(0, decimalLimit);
        }

        mask = mask.concat(fraction);
      }

      if (requireDecimal === true && rawValue[indexOfLastDecimal - 1] === decimalSymbol) {
        mask.push(digitRegExp);
      }
    }

    if (prefixLength > 0) {
      var _prefixArray = prefix.split(emptyString);

      mask = _prefixArray.concat(mask);
    }

    if (isNegative) {
      // If user is entering a negative number, add a mask placeholder spot to attract the caret to it.
      if (mask.length === prefixLength) {
        mask.push(digitRegExp);
      }

      mask = [minusRegExp].concat(mask);
    }

    if (suffix.length > 0) {
      mask = mask.concat(suffix.split(emptyString));
    }

    return mask;
  }

  numberMask.instanceOf = 'createNumberMask';
  return numberMask;
}

function convertToMask(strNumber) {
  return strNumber.split(emptyString).map(char => digitRegExp.test(char) ? digitRegExp : char);
} // http://stackoverflow.com/a/10899795/604296


function addThousandsSeparator(n, thousandsSeparatorSymbol) {
  return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
}
//# sourceMappingURL=create-number-mask-utils.js.map